var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61263 7.27832L7.2793 1.27832C7.80973 1.27832 8.31844 1.48903 8.69351 1.86411C9.06858 2.23918 9.2793 2.74789 9.2793 3.27832V5.94499H13.0526C13.2459 5.9428 13.4373 5.98266 13.6137 6.0618C13.79 6.14094 13.947 6.25748 14.0739 6.40333C14.2007 6.54918 14.2943 6.72087 14.3482 6.90649C14.4021 7.09211 14.415 7.28722 14.386 7.47832L13.466 13.4783C13.4177 13.7963 13.2563 14.0861 13.0112 14.2943C12.7662 14.5026 12.4542 14.6153 12.1326 14.6117H4.61263M4.61263 7.27832V14.6117M4.61263 7.27832H2.61263C2.25901 7.27832 1.91987 7.4188 1.66982 7.66885C1.41977 7.91889 1.2793 8.25803 1.2793 8.61165V13.2783C1.2793 13.6319 1.41977 13.9711 1.66982 14.2211C1.91987 14.4712 2.25901 14.6117 2.61263 14.6117H4.61263",
    stroke: "#576579",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.1f77e1ed9ae3c9b5c20dbab5992f5abf.svg";
export { ForwardRef as ReactComponent };